"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "minturno": {
    "6761c579": [{
      "hkey": "28b679af",
      "slug": "scauri-tremensuoli",
      "name": "Scauri-Tremensuoli",
      "primary": true,
      "skipSearch": false
    }],
    "scauri": [{
      "hkey": "28b679af",
      "slug": "scauri-tremensuoli",
      "name": "Scauri-Tremensuoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f26552ec": [{
      "hkey": "28b679af",
      "slug": "scauri-tremensuoli",
      "name": "Scauri-Tremensuoli",
      "primary": true,
      "skipSearch": false
    }],
    "tremensuoli": [{
      "hkey": "28b679af",
      "slug": "scauri-tremensuoli",
      "name": "Scauri-Tremensuoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "minturno"
    }]
  }
};
exports["default"] = _default;